import sharedStyle from "../style";

const classes = {
  ...sharedStyle,
  article: {
    "& .MuiCardMedia-root ": {
      borderRadius: "12px",
    },
    "& .MuiButton-root": {
      paddingLeft: "40px",
      paddingRight: "40px",
    },
  },
  subtitle: {
    paddingLeft: "10%",
    marginTop: "60px",
    marginBottom: "60px",
  },
  articles: {
    "& .MuiButton-text": {
      fontFamily: "PoppinsRegular,sans-serif",
      textDecoration: "underline",
      color: "#000",
    },
    "& .MuiTypography-h5": {
      textDecoration: "underline",
    },
  },
};
export default classes;
